import { mxgraphInstance } from './mxgraphFactory';
/**
 * mxClient
 */
export var mxClient = mxgraphInstance.mxClient;
//# sourceMappingURL=mxClient.js.map